import {ModuleWithProviders, NgModule} from '@angular/core';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule, CurrencyPipe} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";

import {FUIActionComponent} from "./actions/action/action.component";
import {FUIActionsComponent} from "./actions/actions.component";
import {FUIActionButtonComponent} from "./buttons/button/action-button/action-button.component";
import {FUIActionFixtureComponent} from "./controls/framework/fixtures/action-fixture/action-fixture.component";
import {FUIAlertComponent} from "./alerts/alert/alert.component";
import {FUIAlertsComponent} from "./alerts/alerts.component";
import {FUIAppendFieldComponent} from "./content-layout/fields/field/append-field/append-field.component";
import {FUIAttributedListComponent} from "./lists/attributed-list/attributed-list.component";
import {
    FUIAttributedListEntryComponent
} from "./lists/attributed-list/attributed-list-entry/attributed-list-entry.component";
import {
    FUIAttributedListEntryAttributeComponent
} from "./lists/attributed-list/attributed-list-entry/attributed-list-entry-attributes/attributed-list-entry-attribute/attributed-list-entry-attribute.component";
import {
    FUIAttributedListEntryAttributesComponent
} from "./lists/attributed-list/attributed-list-entry/attributed-list-entry-attributes/attributed-list-entry-attributes.component";
import {FUIAutocompleteControlComponent} from "./controls/autocomplete/autocomplete-control.component";
import {FUIAutocompletePillComponent} from "./controls/autocomplete/pill/autocomplete-pill.component";
import {FUIAutocompleteOptionComponent} from "./controls/autocomplete/options/option/autocomplete-option.component";
import {FUIAutocompleteOptionsComponent} from "./controls/autocomplete/options/autocomplete-options.component";
import {FUIBackgroundVideoComponent} from "./video/background-video/background-video.component";
import {FUIBreadcrumbComponent} from "./breadcrumbs/breadcrumb/breadcrumb.component";
import {FUIBreadcrumbsComponent} from "./breadcrumbs/breadcrumbs.component";
import {FUIButtonComponent} from "./buttons/button/button.component";
import {FUIButtonsComponent} from "./buttons/buttons.component";
import {FUICanvasComponent} from "./canvas/canvas.component";
import {FUICanvasFrameComponent} from "./canvas/canvas-frame/canvas-frame.component";
import {FUICanvasMastheadComponent} from "./canvas/canvas-masthead/canvas-masthead.component";
import {FUICanvasOverlayComponent} from "./canvas/canvas-overlay/canvas-overlay.component";
import {FUICanvasStoryboardComponent} from "./canvas/canvas-storyboard/canvas-storyboard.component";
import {FUICanvasWindowComponent} from "./canvas/canvas-window/canvas-window.component";
import {FUICheckboxControlComponent} from "./controls/checkbox/checkbox-control.component";
import {FUICheckboxDomComponent} from "./controls/checkbox/dom/checkbox-dom.component";
import {FUICheckboxLabelComponent} from "./controls/common-components/checkbox-label/checkbox-label.component";
import {FUICheckboxPillComponent} from "./controls/checkbox/pill/checkbox-pill.component";
import {FUIChoiceButtonComponent} from "./buttons/button/choice-button/choice-button.component";
import {FUIChromeComponent} from "./chrome/chrome.component";
import {FUIChromeActionComponent} from "./chrome/chrome-actions/chrome-action/chrome-action.component";
import {FUIChromeActionsComponent} from "./chrome/chrome-actions/chrome-actions.component";
import {FUIChromeBrandingComponent} from "./chrome/chrome-branding/chrome-branding.component";
import {FUIChromeControlsComponent} from "./chrome/chrome-controls/chrome-controls.component";
import {FUIChromeControlComponent} from "./chrome/chrome-controls/chrome-control/chrome-control.component";
import {
    FUIChromeControlDropdownComponent
} from "./chrome/chrome-controls/chrome-control/chrome-control-dropdown/chrome-control-dropdown.component";
import {
    FUIChromeControlLinkComponent
} from "./chrome/chrome-controls/chrome-control/chrome-control-link/chrome-control-link.component";
import {FUIClearButtonComponent} from "./buttons/button/clear-button/clear-button.component";
import {FUIColorControlComponent} from "./controls/color/color-control.component";
import {FUIColorPopComponent} from "./controls/color/color-pop/color-pop.component";
import {FUIColorPairControlComponent} from "./controls/color-pair/color-pair-control.component";
import {FUIColorPairPopComponent} from "./controls/color-pair/color-pair-pop/color-pair-pop.component";
import {FUIColorPairToggleComponent} from "./controls/color-pair/color-pair-toggle/color-pair-toggle.component";
import {FUIColorPairViewComponent} from "./controls/color-pair/color-pair-view/color-pair-view.component";
import {FUIColumnComponent} from "./content-layout/columns/column/column.component";
import {FUIColumnsComponent} from "./content-layout/columns/columns.component";
import {FUIColumnWidthDirective} from "./content-layout/columns/column-width.directive";
import {FUICommandComponent} from "./commands/command/command.component";
import {FUICommandsComponent} from "./commands/commands.component";
import {
    FUIContentLayoutHeaderControlComponent
} from "./content-layout/header-control/content-layout-header-control.component";
import {FUIContentSectionComponent} from "./sections/section/content-section/content-section.component";
import {FUIContextButtonComponent} from "./buttons/button/context-button/context-button.component";
import {FUIDateControlComponent} from "./controls/date/date-control.component";
import {FUIDottedLoaderComponent} from "./loading/loaders/loader/dotted-loader/dotted-loader.component";
import {FUIEllipsisLoaderComponent} from "./loading/loaders/loader/ellipsis-loader/ellipsis-loader.component";
import {FUIEmptyComponent} from "./empty/empty.component";
import {FUIFieldComponent} from "./content-layout/fields/field/field.component";
import {FUIFieldsComponent} from "./content-layout/fields/fields.component";
import {FUIFormationComponent} from "./content-layout/formation/formation.component";
import {
    FUIFormationGroupComponent
} from "./content-layout/formation/formation-groups/formation-group/formation-group.component";
import {
    FUIFormationGroupTemplateComponent
} from "./content-layout/formation/formation-groups/formation-group-template/formation-group-template.component";
import {FUIFormationGroupsComponent} from "./content-layout/formation/formation-groups/formation-groups.component";
import {
    FUIFormationNavigationComponent
} from "./content-layout/formation/formation-navigation/formation-navigation.component";
import {FUIFormatGroupDirective} from "./content-layout/formation/formation-group.directive";
import {FUIFormStackedFieldComponent} from "./content-layout/fields/field/stacked-field/stacked-field.component";
import {FUIFourColumnsComponent} from "./content-layout/columns/four-columns/four-columns.component";
import {FUIFixtureComponent} from "./controls/framework/fixtures/fixture/fixture.component";
import {FUIFixturesComponent} from "./controls/framework/fixtures/fixtures.component";
import {FUIGroupingFieldComponent} from "./content-layout/fields/field/grouping-field/grouping-field.component";
import {FUIHeaderButtonComponent} from "./buttons/button/header-button/header-button.component";
import {FUIIconComponent} from "./icons/icon/icon.component";
import {FUIIconsComponent} from "./icons/icons.component";
import {FUIImageComponent} from "./controls/image/image.component";
import {FUIImagePopComponent} from "./controls/image/image-pop/image-pop.component";
import {FUIInlineErrorComponent} from "./inline-info/error/inline-error.component";
import {FUIInlineInformationComponent} from "./inline-info/information/inline-information.component";
import {FUIInlineSuccessComponent} from "./inline-info/success/inline-success.component";
import {FUIInlineWarningComponent} from "./inline-info/warning/inline-warning.component";
import {FUILinkButtonComponent} from "./buttons/button/link-button/link-button.component";
import {FUIListSectionComponent} from "./sections/section/list-section/list-section.component";
import {FUILoadingComponent} from "./loading/loading.component";
import {FUILocalisationControlComponent} from "./controls/localisation/localisation-control.component";
import {FUILocalButtonComponent} from "./buttons/button/local-button/local-button.component";
import {FUIMarkToggleComponent} from "./toggle/mark-toggle/mark-toggle.component";
import {FUINavButtonComponent} from "./buttons/button/nav-button/nav-button.component";
import {FUIMarkButtonComponent} from "./buttons/button/mark-button/mark-button.component";
import {FUIMarkLogoComponent} from "./logos/mark-logo/mark-logo.component";
import {FUIMessageLabelComponent} from "./labels/message-label/message-label.component";
import {FUIModalComponent} from "./modals/modal/modal.component";
import {FUIModalsComponent} from "./modals/modals.component";
import {FUIModalWindowComponent} from "./modals/modal/modal-window/modal-window.component";
import {
    FUIModalWindowAlertComponent
} from "./modals/modal/modal-window/modal-window-alert/modal-window-alert.component";
import {
    FUIModalWindowContentComponent
} from "./modals/modal/modal-window/modal-window-content/modal-window-content.component";
import {
    FUIModalWindowFooterComponent
} from "./modals/modal/modal-window/modal-window-footer/modal-window-footer.component";
import {
    FUIModalWindowHeaderComponent
} from "./modals/modal/modal-window/modal-window-header/modal-window-header.component";
import {FUIModalWindowMainComponent} from "./modals/modal/modal-window/modal-window-main/modal-window-main.component";
import {
    FUIModalWindowToolbarComponent
} from "./modals/modal/modal-window/modal-window-toolbar/modal-window-toolbar.component";
import {FUIMoreControlComponent} from "./controls/more/more-control.component";
import {FUIMultiselectControlComponent} from "./controls/multiselect/multiselect-control.component";
import {FUINameValueListComponent} from "./lists/name-value-list/name-value-list.component";
import {
    FUINameValueListEntryComponent
} from "./lists/name-value-list/name-value-list-entry/name-value-list-entry.component";
import {FUINavigationComponent} from "./navigation/navigation.component";
import {
    FUINavigationBranchComponent
} from "./navigation/navigation-branches/navigation-branch/navigation-branch.component";
import {FUINavigationBranchesComponent} from "./navigation/navigation-branches/navigation-branches.component";
import {
    FUINavigationChromeActionComponent
} from "./navigation/navigation-chrome-action/navigation-chrome-action.component";
import {FUINavigationGroupComponent} from "./navigation/navigation-group/navigation-group.component";
import {FUINavigationLinkComponent} from "./navigation/navigation-link/navigation-link.component";
import {FUINavigationSearchComponent} from "./navigation/navigation-search/navigation-search.component";
import {FUINavigationTreeComponent} from "./navigation/navigation-trees/navigation-tree/navigation-tree.component";
import {FUINavigationTreesComponent} from "./navigation/navigation-trees/navigation-trees.component";
import {FUINavLayoutComponent} from "./nav-layout/nav-layout.component";
import {FUINotationComponent} from "./controls/framework/notation/notation.component";
import {FUINumericControlComponent} from "./controls/numeric/numeric-control.component";
import {FUIOutlineButtonComponent} from "./buttons/button/outline-button/outline-button.component";
import {FUIPageBodyComponent} from "./page/page-body/page-body.component";
import {FUIPageComponent} from "./page/page.component";
import {FUIPageContentComponent} from "./page/page-content/page-content.component";
import {
    FUIPageContentSectionComponent
} from "./page/page-content/page-content-sections/page-content-section/page-content-section.component";
import {
    FUIPageContentSectionsComponent
} from "./page/page-content/page-content-sections/page-content-sections.component";
import {FUIPageFooterComponent} from "./page/page-footer/page-footer.component";
import {FUIPageHeaderComponent} from "./page/page-header/page-header.component";
import {FUIPageHeaderHeadingComponent} from "./page/page-header/page-header-heading/page-header-heading.component";
import {FUIPageHeaderNavComponent} from "./page/page-header/page-header-nav/page-header-nav.component";
import {FUIPageMainComponent} from "./page/page-main/page-main.component";
import {FUIPagePaneComponent} from "./page/page-pane/page-pane.component";
import {FUIPageRefreshComponent} from "./page/page-refresh/page-refresh.component";
import {FUIPageSidePanelComponent} from "./page/page-side-panel/page-side-panel.component";
import {FUIPageSubjectComponent} from "./page/page-subject/page-subject.component";
import {FUIPageUtilityComponent} from "./page/page-utility/page-utility.component";
import {FUIPasswordControlComponent} from "./controls/password/password-control.component";
import {FUIPanelComponent} from "./panels/panel/panel.component";
import {FUIPanelsComponent} from "./panels/panels.component";
import {FUIPanelsAlertComponent} from "./panels/panels-alert/panels-alert.component";
import {FUIPodiumComponent} from "./podium/podium.component";
import {FUIPopButtonComponent} from "./buttons/button/pop-button/pop-button.component";
import {FUIPopsComponent} from "./pops/pops.component";
import {FUIPOSLogoComponent} from "./logos/pos-logo/pos-logo.component";
import {FUIPrependFieldComponent} from "./content-layout/fields/field/prepend-field/prepend-field.component";
import {FUIRadioGroupComponent} from "./controls/radio/radio-group/radio-group.component";
import {FUIRadioControlComponent} from "./controls/radio/radio-control.component";
import {FUIRowComponent} from "./content-layout/rows/row/row.component";
import {FUISimpleRowComponent} from "./content-layout/rows/simple-row/simple-row.component";
import {FUIRowsComponent} from "./content-layout/rows/rows.component";
import {FUISearchControlComponent} from "./controls/search/search-control.component";
import {FUISectionComponent} from "./sections/section/section.component";
import {FUISectionsComponent} from "./sections/sections.component";
import {FUISectionToggleComponent} from "./toggle/section-toggle/section-toggle.component";
import {FUISelectControlComponent} from "./controls/select/select-control.component";
import {FUISetComponent} from "./content-layout/set/set.component";
import {FUISpinnerComponent} from "./spinners/spinner/spinner.component";
import {FUISpinnersComponent} from "./spinners/spinners.component";
import {FUIStackedPageModalComponent} from "./stacked-page/stacked-page-modal/stacked-page-modal.component";
import {FUISpanningFixtureComponent} from "./controls/framework/fixtures/spanning-fixture/spanning-fixture.component";
import {FUIStatementComponent} from "./statements/statement/statement.component";
import {FUIStatementsComponent} from "./statements/statements.component";
import {FUISpinningLoaderComponent} from "./loading/loaders/loader/spinning-loader/spinning-loader.component";
import {FUISubmitButtonComponent} from "./buttons/button/submit-button/submit-button.component";
import {FUISummaryComponent} from "./summary/summary.component";
import {FUITabComponent} from "./tabs/tab/tab.component";
import {FUITabsComponent} from "./tabs/tabs.component";
import {FUITagComponent} from "./tags/tag/tag.component";
import {FUITagsComponent} from "./tags/tags.component";
import {FUITandemFieldComponent} from "./content-layout/fields/field/tandem-field/tandem-field.component";
import {FUITextareaControlComponent} from "./controls/textarea/textarea-control.component";
import {FUITextControlComponent} from "./controls/text/text-control.component";
import {FUITextPillComponent} from "./controls/text/pill/text-pill.component";
import {FUITimeControlComponent} from "./controls/time/time-control.component";
import {FUITreesComponent} from "./trees/trees.component";
import {FUITreeComponent} from "./trees/tree/tree.component";
import {FUIThreeColumnsComponent} from "./content-layout/columns/three-columns/three-columns.component";
import {FUITwoColumnsComponent} from "./content-layout/columns/two-columns/two-columns.component";
import {FUIValueStatementComponent} from "./statements/statement/value-statement/value-statement.component";
import {FUIVideoComponent} from "./video/video.component";
import {FUISwitchControlComponent} from "./controls/switch/switch-control.component";
import {FUICalculatorControlComponent} from "./controls/calculator/calculator-control.component";
import {FUIKeysControlComponent} from "./controls/keys/keys-control.component";
import {FUIKeyComponent} from "./controls/keys/key/key.component";
import {FUIPinsControlComponent} from "./controls/pins/pins-control.component";
import {FUIPinComponent} from "./controls/pins/pin/pin.component";
import {FUIQuantityControlComponent} from "./controls/quantity/quantity-control.component";
import {FUIImageControlComponent} from "./controls/image/image-control.component";
import {FUISelectNavComponent} from "./select-nav/select-nav.component";
import {FUIEditFormContextComponent} from "./form-context/edit-form-context.component";
import {FUIFilterFormContextComponent} from "./form-context/filter-form-context.component";
import {FUIHeaderFormContextComponent} from "./form-context/header-form-context.component";
import {FUIInlineFormContextComponent} from "./form-context/inline-form-context.component";
import {FUIInlineActionFormContextComponent} from "./form-context/inline-action-form-context.component";
import {FUIPillFormContextComponent} from "./form-context/pill-form-context.component";
import {FUIPopFormContextComponent} from "./form-context/pop-form-context.component";
import {FUITouchDirective} from "./touch/touch.directive";
import {ColorTextPipe} from "./controls/color/inputs/color-text.pipe";
import {FUIDatePopComponent} from "./controls/date/date-pop/date-pop.component";
import {FUICommandPopComponent} from "./commands/command-pop/command-pop.component";
import {
    FUIEditAutocompleteInputComponent
} from "./controls/autocomplete/inputs/edit-autocomplete-input/edit-autocomplete-input.component";
import {
    FUIEditCheckboxInputComponent
} from "./controls/checkbox/inputs/edit-checkbox-input/edit-checkbox-input.component";
import {FUIEditColorInputComponent} from "./controls/color/inputs/edit-color-input/edit-color-input.component";
import {
    FUIEditColorPairInputComponent
} from "./controls/color-pair/inputs/edit-color-pair-input/edit-color-pair-input.component";
import {FUIEditDateInputComponent} from "./controls/date/inputs/edit-date-input/edit-date-input.component";
import {FUIEditFasciaComponent} from "./controls/framework/fascias/edit-fascia/edit-fascia.component";
import {FUIEditImageInputComponent} from "./controls/image/inputs/edit-image-input/edit-image-input.component";
import {
    FUIEditLocalisationInputComponent
} from "./controls/localisation/inputs/edit-localisation-input/edit-localisation-input.component";
import {FUIEditNumericInputComponent} from "./controls/numeric/inputs/edit-numeric-input/edit-numeric-input.component";
import {FUIEditMoreInputComponent} from "./controls/more/inputs/edit-more-input/edit-more-input.component";
import {
    FUIEditMultiselectInputComponent
} from "./controls/multiselect/inputs/edit-multiselect-input/edit-multiselect-input.component";
import {
    FUIEditPasswordInputComponent
} from "./controls/password/inputs/edit-password-input/edit-password-input.component";
import {FUIEditRadioInputComponent} from "./controls/radio/inputs/edit-radio-input/edit-radio-input.component";
import {FUIEditSearchInputComponent} from "./controls/search/inputs/edit-search-input/edit-search-input.component";
import {FUIEditSelectInputComponent} from "./controls/select/inputs/edit-select-input/edit-select-input.component";
import {FUIEditSwitchInputComponent} from "./controls/switch/inputs/edit-switch-input/edit-switch-input.component";
import {
    FUIEditTextareaInputComponent
} from "./controls/textarea/inputs/edit-textarea-input/edit-textarea-input.component";
import {FUIEditTextInputComponent} from "./controls/text/inputs/edit-text-input/edit-text-input.component";
import {FUIEditTimeInputComponent} from "./controls/time/inputs/edit-time-input/edit-time-input.component";
import {
    FUIErrorValidationComponent
} from "./controls/framework/validations/validation/error-validation/error-validation.component";
import {FUIFABSectionComponent} from "./sections/section/fab-section/fab-section.component";
import {
    FUIFilterAutocompleteInputComponent
} from "./controls/autocomplete/inputs/filter-autocomplete-input/filter-autocomplete-input.component";
import {
    FUIFilterCheckboxInputComponent
} from "./controls/checkbox/inputs/filter-checkbox-input/filter-checkbox-input.component";
import {FUIFilterDateInputComponent} from "./controls/date/inputs/filter-date-input/filter-date-input.component";
import {FUIFilterFasciaComponent} from "./controls/framework/fascias/filter-fascia/filter-fascia.component";
import {
    FUIFilterLocalisationInputComponent
} from "./controls/localisation/inputs/filter-localisation-input/filter-localisation-input.component";
import {FUIFilterMoreInputComponent} from "./controls/more/inputs/filter-more-input/filter-more-input.component";
import {
    FUIFilterMultiselectInputComponent
} from "./controls/multiselect/inputs/filter-multiselect-input/filter-multiselect-input.component";
import {
    FUIPillMultiselectInputComponent
} from "./controls/multiselect/inputs/pill-multiselect-input/pill-multiselect-input.component";
import {
    FUIFilterNumericInputComponent
} from "./controls/numeric/inputs/filter-numeric-input/filter-numeric-input.component";
import {
    FUIFilterPasswordInputComponent
} from "./controls/password/inputs/filter-password-input/filter-password-input.component";
import {FUIFilterRadioInputComponent} from "./controls/radio/inputs/filter-radio-input/filter-radio-input.component";
import {
    FUIFilterSearchInputComponent
} from "./controls/search/inputs/filter-search-input/filter-search-input.component";
import {
    FUIFilterSelectInputComponent
} from "./controls/select/inputs/filter-select-input/filter-select-input.component";
import {
    FUIFilterSwitchInputComponent
} from "./controls/switch/inputs/filter-switch-input/filter-switch-input.component";
import {
    FUIFilterTextareaInputComponent
} from "./controls/textarea/inputs/filter-textarea-input/filter-textarea-input.component";
import {FUIFilterTextInputComponent} from "./controls/text/inputs/filter-text-input/filter-text-input.component";
import {FUIFilterTimeInputComponent} from "./controls/time/inputs/filter-time-input/filter-time-input.component";
import {FUIFragmentComponent} from "./fragments/fragment/fragment.component";
import {FUIFragmentsComponent} from "./fragments/fragments.component";
import {FUIFTBSectionComponent} from "./sections/section/ftb-section/ftb-section.component";
import {FUIHeaderFasciaComponent} from "./controls/framework/fascias/header-fascia/header-fascia.component";
import {FUIHeaderMoreInputComponent} from "./controls/more/inputs/header-more-input/header-more-input.component";
import {
    FUIHeaderNumericInputComponent
} from "./controls/numeric/inputs/header-numeric-input/header-numeric-input.component";
import {
    FUIHeaderSelectInputComponent
} from "./controls/select/inputs/header-select-input/header-select-input.component";
import {FUIInjectablesComponent} from "./injectables/injectables.component";
import {
    FUIInlineAutocompleteInputComponent
} from "./controls/autocomplete/inputs/inline-autocomplete-input/inline-autocomplete-input.component";
import {
    FUIInlineCheckboxInputComponent
} from "./controls/checkbox/inputs/inline-checkbox-input/inline-checkbox-input.component";
import {FUIInlineColorInputComponent} from "./controls/color/inputs/inline-color-input/inline-color-input.component";
import {
    FUIInlineColorPairInputComponent
} from "./controls/color-pair/inputs/inline-color-pair-input/inline-color-pair-input.component";
import {FUIInlineDateInputComponent} from "./controls/date/inputs/inline-date-input/inline-date-input.component";
import {FUIInlineFasciaComponent} from "./controls/framework/fascias/inline-fascia/inline-fascia.component";
import {FUIInlineImageInputComponent} from "./controls/image/inputs/inline-image-input/inline-image-input.component";
import {
    FUIInlineLocalisationInputComponent
} from "./controls/localisation/inputs/inline-localisation-input/inline-localisation-input.component";
import {FUIInlineMoreInputComponent} from "./controls/more/inputs/inline-more-input/inline-more-input.component";
import {
    FUIInlineMultiselectInputComponent
} from "./controls/multiselect/inputs/inline-multiselect-input/inline-multiselect-input.component";
import {
    FUIInlineNumericInputComponent
} from "./controls/numeric/inputs/inline-numeric-input/inline-numeric-input.component";
import {
    FUIInlinePasswordInputComponent
} from "./controls/password/inputs/inline-password-input/inline-password-input.component";
import {FUIInlineRadioInputComponent} from "./controls/radio/inputs/inline-radio-input/inline-radio-input.component";
import {
    FUIInlineSearchInputComponent
} from "./controls/search/inputs/inline-search-input/inline-search-input.component";
import {
    FUIInlineSelectInputComponent
} from "./controls/select/inputs/inline-select-input/inline-select-input.component";
import {
    FUIInlineSwitchInputComponent
} from "./controls/switch/inputs/inline-switch-input/inline-switch-input.component";
import {FUIInlineTextInputComponent} from "./controls/text/inputs/inline-text-input/inline-text-input.component";
import {
    FUIInlineTextareaInputComponent
} from "./controls/textarea/inputs/inline-textarea-input/inline-textarea-input.component";
import {FUIInlineTimeInputComponent} from "./controls/time/inputs/inline-time-input/inline-time-input.component";
import {FUIInputDomComponent} from "./controls/common-components/input-dom/input-dom.component";
import {FUIInputLabelComponent} from "./controls/common-components/input-label/input-label.component";
import {FUILimitTotalComponent} from "./limit-total/limit-total.component";
import {FUILocalisationPillComponent} from "./controls/localisation/pill/localisation-pill.component";
import {
    FUIMandatoryValidationComponent
} from "./controls/framework/validations/validation/mandatory-validation/mandatory-validation.component";
import {FUIMorePillComponent} from "./controls/more/pill/more-pill.component";
import {FUIMultiselectOptionComponent} from "./controls/multiselect/options/option/multiselect-option.component";
import {FUIMultiselectOptionsComponent} from "./controls/multiselect/options/multiselect-options.component";
import {FUINotImplementedComponent} from "./not-implemented/not-implemented.component";
import {FUINumericPillComponent} from "./controls/numeric/pill/numeric-pill.component";
import {FUIPillFasciaComponent} from "./controls/framework/fascias/pill-fascia/pill-fascia.component";
import {FUIPasswordPillComponent} from "./controls/password/pill/password-pill.component";
import {FUIPillDateInputComponent} from "./controls/date/inputs/pill-date-input/pill-date-input.component";
import {FUIPillLabelComponent} from "./controls/common-components/pill-label/pill-label.component";
import {FUIPillSelectInputComponent} from "./controls/select/inputs/pill-select-input/pill-select-input.component";
import {FUIPillTimeInputComponent} from "./controls/time/inputs/pill-time-input/pill-time-input.component";
import {FUIPopCheckboxInputComponent} from "./controls/checkbox/inputs/pop-checkbox-input/pop-checkbox-input.component";
import {
    FUIPopCheckboxLabelComponent
} from "./controls/common-components/pop-checkbox-label/pop-checkbox-label.component";
import {FUIPopFasciaComponent} from "./controls/framework/fascias/pop-fascia/pop-fascia.component";
import {
    FUIPopLocalisationInputComponent
} from "./controls/localisation/inputs/pop-localisation-input/pop-localisation-input.component";
import {FUIPopMoreInputComponent} from "./controls/more/inputs/pop-more-input/pop-more-input.component";
import {FUIPopPasswordInputComponent} from "./controls/password/inputs/pop-password-input/pop-password-input.component";
import {FUIPopSearchInputComponent} from "./controls/search/inputs/pop-search-input/pop-search-input.component";
import {FUIPopSwitchInputComponent} from "./controls/switch/inputs/pop-switch-input/pop-switch-input.component";
import {FUIRadioPillComponent} from "./controls/radio/pill/radio-pill.component";
import {FUISearchPillComponent} from "./controls/search/pill/search-pill.component";
import {FUIFilterLabelComponent} from "./controls/common-components/filter-label/filter-label.component";
import {FUISelectOptionComponent} from "./controls/select/options/option/select-option.component";
import {FUISelectOptionsComponent} from "./controls/select/options/select-options.component";
import {FUISelectPopComponent} from "./controls/common-components/select-pop/select-pop.component";
import {
    FUISuccessValidationComponent
} from "./controls/framework/validations/validation/success-validation/success-validation.component";
import {FUISwitchDomComponent} from "./controls/switch/dom/switch-dom.component";
import {FUITextareaDomComponent} from "./controls/textarea/dom/textarea-dom.component";
import {FUITextareaPillComponent} from "./controls/textarea/pill/textarea-pill.component";
import {FUITimePopComponent} from "./controls/time/time-pop/time-pop.component";
import {FUIValidationPopComponent} from "./controls/framework/validations/validation-pop/validation-pop.component";
import {FUIValidationsComponent} from "./controls/framework/validations/validations.component";
import {FUIAlertService} from "./alerts/alert.service";
import {FUIEditFormContext} from "./form-context/edit-form-context";
import {FUIEventsService} from "./events/events.service";
import {FUIFilterFormContext} from "./form-context/filter-form-context";
import {FUIHeaderFormContext} from "./form-context/header-form-context";
import {FUIInlineFormContext} from "./form-context/inline-form-context";
import {FUIInlineActionFormContext} from "./form-context/inline-action-form-context";
import {FUIPillFormContext} from "./form-context/pill-form-context";
import {FUIPopFormContext} from "./form-context/pop-form-context";
import {FUIModalsService} from "./modals/modals.service";
import {FUIPopsService} from "./pops/pops.service";
import {FUIStackedPageService} from "./stacked-page/stacked-page.service";
import {FUINavigationService} from "./navigation/navigation.service";
import {FUINavLayoutService} from "./nav-layout/nav-layout.service";
import {FUIPageService} from "./page/page.service";
import {FUIResponsiveService} from "./page/responsive.service";
import {FUISpinnersService} from "./spinners/spinners.service";
import {FUIConfig} from "./fui.config";
import {ColorPickerModule} from "ngx-color-picker";
import {SliderModule} from "@progress/kendo-angular-inputs";
import {DateInputsModule, TimeSelectorComponent} from "@progress/kendo-angular-dateinputs";
import {NgClickOutsideDirective} from "ng-click-outside2";
import {FUIRadioDomComponent} from "./controls/radio/dom/radio-dom.component";
import {TranslateModule} from "@ngx-translate/core";
import {
    FUIDeprecatedAutocompleteControlComponent
} from "./controls/deprecated-autocomplete-control/deprecated-autocomplete-control.component";
import {
    FUIDeprecatedAutocompleteControlResultsComponent
} from "./controls/deprecated-autocomplete-control/deprecated-autocomplete-control-results/deprecated-autocomplete-control-results.component";
import {FUIDeprecatedTextControlComponent} from "./controls/deprecated-text-control/deprecated-text-control.component";
import {
    FUIDeprecatedAutocompleteControlResultComponent
} from "./controls/deprecated-autocomplete-control/deprecated-autocomplete-control-results/deprecated-autocomplete-control-result/deprecated-autocomplete-control-result.component";
import {FUITimeSelectorComponent} from "./controls/time/time-selector/time-selector.component";

@NgModule({
    imports: [
        BrowserAnimationsModule,
        ColorPickerModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        SliderModule,
        DateInputsModule,
        NgClickOutsideDirective,
        TimeSelectorComponent,
        TranslateModule
    ],
    declarations: [
        FUIActionComponent,
        FUIActionsComponent,
        FUIActionButtonComponent,
        FUIActionFixtureComponent,
        FUIAlertComponent,
        FUIAlertsComponent,
        FUIAppendFieldComponent,
        FUIAttributedListComponent,
        FUIAttributedListEntryComponent,
        FUIAttributedListEntryAttributeComponent,
        FUIAttributedListEntryAttributesComponent,
        FUIAutocompleteControlComponent,
        FUIAutocompletePillComponent,
        FUIAutocompleteOptionComponent,
        FUIAutocompleteOptionsComponent,
        FUIBackgroundVideoComponent,
        FUIBreadcrumbComponent,
        FUIBreadcrumbsComponent,
        FUIButtonComponent,
        FUIButtonsComponent,
        FUICanvasComponent,
        FUICanvasFrameComponent,
        FUICanvasMastheadComponent,
        FUICanvasOverlayComponent,
        FUICanvasStoryboardComponent,
        FUICanvasWindowComponent,
        FUICheckboxControlComponent,
        FUICheckboxDomComponent,
        FUICheckboxLabelComponent,
        FUICheckboxPillComponent,
        FUIChoiceButtonComponent,
        FUIChromeComponent,
        FUIChromeActionComponent,
        FUIChromeActionsComponent,
        FUIChromeBrandingComponent,
        FUIChromeControlsComponent,
        FUIChromeControlComponent,
        FUIChromeControlDropdownComponent,
        FUIChromeControlLinkComponent,
        FUIClearButtonComponent,
        FUIColorControlComponent,
        FUIColorPopComponent,
        FUIColorPairControlComponent,
        FUIColorPairPopComponent,
        FUIColorPairToggleComponent,
        FUIColorPairViewComponent,
        FUIColumnComponent,
        FUIColumnsComponent,
        FUIColumnWidthDirective,
        FUICommandComponent,
        FUICommandsComponent,
        FUIContentLayoutHeaderControlComponent,
        FUIContentSectionComponent,
        FUIContextButtonComponent,
        FUIDateControlComponent,
        FUIDatePopComponent,
        FUIDeprecatedAutocompleteControlComponent,
        FUIDeprecatedAutocompleteControlResultComponent,
        FUIDeprecatedAutocompleteControlResultsComponent,
        FUIDeprecatedTextControlComponent,
        FUIDottedLoaderComponent,
        FUICommandPopComponent,
        FUIEditAutocompleteInputComponent,
        FUIEditCheckboxInputComponent,
        FUIEditColorInputComponent,
        FUIEditColorPairInputComponent,
        FUIEditDateInputComponent,
        FUIEditFasciaComponent,
        FUIEditImageInputComponent,
        FUIEditLocalisationInputComponent,
        FUIEditNumericInputComponent,
        FUIEditMoreInputComponent,
        FUIEditMultiselectInputComponent,
        FUIEditPasswordInputComponent,
        FUIEditRadioInputComponent,
        FUIEditSearchInputComponent,
        FUIEditSelectInputComponent,
        FUIEditSwitchInputComponent,
        FUIEditTextareaInputComponent,
        FUIEditTextInputComponent,
        FUIEditTimeInputComponent,
        FUIEllipsisLoaderComponent,
        FUIEmptyComponent,
        FUIErrorValidationComponent,
        FUIFABSectionComponent,
        FUIFieldComponent,
        FUIFieldsComponent,
        FUIFilterAutocompleteInputComponent,
        FUIFilterCheckboxInputComponent,
        FUIFilterDateInputComponent,
        FUIFilterFasciaComponent,
        FUIFilterLocalisationInputComponent,
        FUIFilterMoreInputComponent,
        FUIFilterMultiselectInputComponent,
        FUIPillMultiselectInputComponent,
        FUIFilterNumericInputComponent,
        FUIFilterPasswordInputComponent,
        FUIFilterRadioInputComponent,
        FUIFilterSearchInputComponent,
        FUIFilterSelectInputComponent,
        FUIFilterSwitchInputComponent,
        FUIFilterTextareaInputComponent,
        FUIFilterTextInputComponent,
        FUIFilterTimeInputComponent,
        FUIFixtureComponent,
        FUIFixturesComponent,
        FUIFormationComponent,
        FUIFormationGroupComponent,
        FUIFormationGroupTemplateComponent,
        FUIFormationGroupsComponent,
        FUIFormationNavigationComponent,
        FUIFormatGroupDirective,
        FUIFormStackedFieldComponent,
        FUIFourColumnsComponent,
        FUIFragmentComponent,
        FUIFragmentsComponent,
        FUIFTBSectionComponent,
        FUIGroupingFieldComponent,
        FUIHeaderButtonComponent,
        FUIHeaderFasciaComponent,
        FUIHeaderMoreInputComponent,
        FUIHeaderNumericInputComponent,
        FUIHeaderSelectInputComponent,
        FUIIconComponent,
        FUIIconsComponent,
        FUIImageComponent,
        FUIImagePopComponent,
        FUIInjectablesComponent,
        FUIInlineErrorComponent,
        FUIInlineInformationComponent,
        FUIInlineSuccessComponent,
        FUIInlineWarningComponent,
        FUIInlineAutocompleteInputComponent,
        FUIInlineCheckboxInputComponent,
        FUIInlineColorInputComponent,
        FUIInlineColorPairInputComponent,
        FUIInlineDateInputComponent,
        FUIInlineFasciaComponent,
        FUIInlineImageInputComponent,
        FUIInlineLocalisationInputComponent,
        FUIInlineMoreInputComponent,
        FUIInlineMultiselectInputComponent,
        FUIInlineNumericInputComponent,
        FUIInlinePasswordInputComponent,
        FUIInlineRadioInputComponent,
        FUIInlineSearchInputComponent,
        FUIInlineSelectInputComponent,
        FUIInlineSwitchInputComponent,
        FUIInlineTextInputComponent,
        FUIInlineTextareaInputComponent,
        FUIInlineTimeInputComponent,
        FUIInputDomComponent,
        FUIInputLabelComponent,
        FUILimitTotalComponent,
        FUILinkButtonComponent,
        FUIListSectionComponent,
        FUILoadingComponent,
        FUILocalisationControlComponent,
        FUILocalisationPillComponent,
        FUILocalButtonComponent,
        FUINavButtonComponent,
        FUIMandatoryValidationComponent,
        FUIMarkButtonComponent,
        FUIMarkLogoComponent,
        FUIMarkToggleComponent,
        FUIMessageLabelComponent,
        FUIModalComponent,
        FUIModalsComponent,
        FUIModalWindowComponent,
        FUIModalWindowAlertComponent,
        FUIModalWindowContentComponent,
        FUIModalWindowFooterComponent,
        FUIModalWindowHeaderComponent,
        FUIModalWindowMainComponent,
        FUIModalWindowToolbarComponent,
        FUIMoreControlComponent,
        FUIMorePillComponent,
        FUIMultiselectControlComponent,
        FUIMultiselectOptionComponent,
        FUIMultiselectOptionsComponent,
        FUINameValueListComponent,
        FUINameValueListEntryComponent,
        FUINavigationComponent,
        FUINavigationBranchComponent,
        FUINavigationBranchesComponent,
        FUINavigationChromeActionComponent,
        FUINavigationGroupComponent,
        FUINavigationLinkComponent,
        FUINavigationSearchComponent,
        FUINavigationTreeComponent,
        FUINavigationTreesComponent,
        FUINavLayoutComponent,
        FUINotationComponent,
        FUINotImplementedComponent,
        FUINumericControlComponent,
        FUINumericPillComponent,
        FUIOutlineButtonComponent,
        FUIPanelComponent,
        FUIPanelsComponent,
        FUIPanelsAlertComponent,
        FUIPageBodyComponent,
        FUIPageComponent,
        FUIPageContentComponent,
        FUIPageContentSectionComponent,
        FUIPageContentSectionsComponent,
        FUIPageFooterComponent,
        FUIPageHeaderComponent,
        FUIPageHeaderHeadingComponent,
        FUIPageHeaderNavComponent,
        FUIPageMainComponent,
        FUIPagePaneComponent,
        FUIPageRefreshComponent,
        FUIPageSidePanelComponent,
        FUIPageSubjectComponent,
        FUIPageUtilityComponent,
        FUIPasswordControlComponent,
        FUIPasswordPillComponent,
        FUIPillDateInputComponent,
        FUIPillFasciaComponent,
        FUIPillLabelComponent,
        FUIPillSelectInputComponent,
        FUIPillTimeInputComponent,
        FUIPodiumComponent,
        FUIPopButtonComponent,
        FUIPopCheckboxInputComponent,
        FUIPopCheckboxLabelComponent,
        FUIPopFasciaComponent,
        FUIPopLocalisationInputComponent,
        FUIPopMoreInputComponent,
        FUIPopPasswordInputComponent,
        FUIPopSearchInputComponent,
        FUIPopSwitchInputComponent,
        FUIPopsComponent,
        FUIPOSLogoComponent,
        FUIPrependFieldComponent,
        FUIRadioGroupComponent,
        FUIRadioControlComponent,
        FUIRadioDomComponent,
        FUIRadioPillComponent,
        FUIRowComponent,
        FUISimpleRowComponent,
        FUIRowsComponent,
        FUISearchControlComponent,
        FUISearchPillComponent,
        FUIFilterLabelComponent,
        FUISectionComponent,
        FUISectionsComponent,
        FUISectionToggleComponent,
        FUISelectControlComponent,
        FUISelectOptionComponent,
        FUISelectOptionsComponent,
        FUISelectPopComponent,
        FUISetComponent,
        FUISpanningFixtureComponent,
        FUISpinnerComponent,
        FUISpinnersComponent,
        FUISpinningLoaderComponent,
        FUIStackedPageModalComponent,
        FUIStatementComponent,
        FUIStatementsComponent,
        FUISubmitButtonComponent,
        FUISuccessValidationComponent,
        FUISwitchControlComponent,
        FUISwitchDomComponent,
        FUISummaryComponent,
        FUITabComponent,
        FUITabsComponent,
        FUITagComponent,
        FUITagsComponent,
        FUITandemFieldComponent,
        FUITextareaControlComponent,
        FUITextareaDomComponent,
        FUITextareaPillComponent,
        FUITextControlComponent,
        FUITextPillComponent,
        FUITimeControlComponent,
        FUITimePopComponent,
        FUITimeSelectorComponent,
        FUITreesComponent,
        FUITreeComponent,
        FUIThreeColumnsComponent,
        FUITwoColumnsComponent,
        FUIValidationPopComponent,
        FUIValidationsComponent,
        FUIValueStatementComponent,
        FUIVideoComponent,
        FUIKeysControlComponent,
        FUIKeyComponent,
        FUIPinsControlComponent,
        FUIPinComponent,
        FUIQuantityControlComponent,
        FUIImageControlComponent,
        FUISelectNavComponent,

        FUIEditFormContextComponent,
        FUIFilterFormContextComponent,
        FUIHeaderFormContextComponent,
        FUIInlineFormContextComponent,
        FUIInlineActionFormContextComponent,
        FUIPillFormContextComponent,
        FUIPopFormContextComponent,

        FUICalculatorControlComponent,

        FUITouchDirective,

        ColorTextPipe
    ],
    exports: [
        FUIActionComponent,
        FUIActionsComponent,
        FUIActionButtonComponent,
        FUIActionFixtureComponent,
        FUIAlertComponent,
        FUIAlertsComponent,
        FUIAppendFieldComponent,
        FUIAttributedListComponent,
        FUIAttributedListEntryComponent,
        FUIAttributedListEntryAttributeComponent,
        FUIAttributedListEntryAttributesComponent,
        FUIAutocompleteControlComponent,
        FUIBackgroundVideoComponent,
        FUIBreadcrumbComponent,
        FUIBreadcrumbsComponent,
        FUIButtonComponent,
        FUIButtonsComponent,
        FUICanvasComponent,
        FUICanvasFrameComponent,
        FUICanvasMastheadComponent,
        FUICanvasOverlayComponent,
        FUICanvasStoryboardComponent,
        FUICanvasWindowComponent,
        FUICheckboxControlComponent,
        FUIChoiceButtonComponent,
        FUIChromeComponent,
        FUIChromeActionComponent,
        FUIChromeActionsComponent,
        FUIChromeBrandingComponent,
        FUIChromeControlsComponent,
        FUIChromeControlComponent,
        FUIChromeControlDropdownComponent,
        FUIChromeControlLinkComponent,
        FUIClearButtonComponent,
        FUIColorControlComponent,
        FUIColorPairControlComponent,
        FUIColorPairViewComponent,
        FUIColorPairToggleComponent,
        FUIColumnComponent,
        FUIColumnsComponent,
        FUIColumnWidthDirective,
        FUICommandComponent,
        FUICommandsComponent,
        FUIContentLayoutHeaderControlComponent,
        FUIContentSectionComponent,
        FUIContextButtonComponent,
        FUIDateControlComponent,
        FUIDeprecatedAutocompleteControlComponent,
        FUIDeprecatedAutocompleteControlResultComponent,
        FUIDeprecatedAutocompleteControlResultsComponent,
        FUIDeprecatedTextControlComponent,
        FUIDottedLoaderComponent,
        FUIEllipsisLoaderComponent,
        FUIEmptyComponent,
        FUIFieldComponent,
        FUIFieldsComponent,
        FUIFormationComponent,
        FUIFormationGroupComponent,
        FUIFormationGroupTemplateComponent,
        FUIFormationGroupsComponent,
        FUIFormationNavigationComponent,
        FUIFormatGroupDirective,
        FUIFormStackedFieldComponent,
        FUIFourColumnsComponent,
        FUIFixtureComponent,
        FUIFixturesComponent,
        FUIGroupingFieldComponent,
        FUIHeaderButtonComponent,
        FUIIconComponent,
        FUIIconsComponent,
        FUIImageComponent,
        FUIImagePopComponent,
        FUIInlineErrorComponent,
        FUIInlineInformationComponent,
        FUIInlineSuccessComponent,
        FUIInlineWarningComponent,
        FUILinkButtonComponent,
        FUIListSectionComponent,
        FUILoadingComponent,
        FUILocalisationControlComponent,
        FUILocalButtonComponent,
        FUIMarkToggleComponent,
        FUINavButtonComponent,
        FUIMarkButtonComponent,
        FUIMarkLogoComponent,
        FUIMessageLabelComponent,
        FUIModalComponent,
        FUIModalsComponent,
        FUIModalWindowComponent,
        FUIModalWindowAlertComponent,
        FUIModalWindowContentComponent,
        FUIModalWindowFooterComponent,
        FUIModalWindowHeaderComponent,
        FUIModalWindowMainComponent,
        FUIModalWindowToolbarComponent,
        FUIMoreControlComponent,
        FUIMultiselectControlComponent,
        FUINameValueListComponent,
        FUINameValueListEntryComponent,
        FUINavigationComponent,
        FUINavigationBranchComponent,
        FUINavigationBranchesComponent,
        FUINavigationChromeActionComponent,
        FUINavigationGroupComponent,
        FUINavigationLinkComponent,
        FUINavigationSearchComponent,
        FUINavigationTreeComponent,
        FUINavigationTreesComponent,
        FUINavLayoutComponent,
        FUINotationComponent,
        FUINumericControlComponent,
        FUIOutlineButtonComponent,
        FUIPageBodyComponent,
        FUIPageComponent,
        FUIPageContentComponent,
        FUIPageContentSectionComponent,
        FUIPageContentSectionsComponent,
        FUIPageFooterComponent,
        FUIPageHeaderComponent,
        FUIPageHeaderHeadingComponent,
        FUIPageHeaderNavComponent,
        FUIPageMainComponent,
        FUIPagePaneComponent,
        FUIPageRefreshComponent,
        FUIPageSidePanelComponent,
        FUIPageSubjectComponent,
        FUIPageUtilityComponent,
        FUIPasswordControlComponent,
        FUIPanelComponent,
        FUIPanelsComponent,
        FUIPanelsAlertComponent,
        FUIPodiumComponent,
        FUIPopButtonComponent,
        FUIPopsComponent,
        FUIPOSLogoComponent,
        FUIPrependFieldComponent,
        FUIRadioGroupComponent,
        FUIRadioControlComponent,
        FUIRowComponent,
        FUISimpleRowComponent,
        FUIRowsComponent,
        FUISearchControlComponent,
        FUISectionComponent,
        FUISectionsComponent,
        FUISectionToggleComponent,
        FUISelectControlComponent,
        FUISetComponent,
        FUISpinnerComponent,
        FUISpinnersComponent,
        FUIStackedPageModalComponent,
        FUISpanningFixtureComponent,
        FUIStatementComponent,
        FUIStatementsComponent,
        FUISpinningLoaderComponent,
        FUISubmitButtonComponent,
        FUISummaryComponent,
        FUITabComponent,
        FUITabsComponent,
        FUITagComponent,
        FUITagsComponent,
        FUITandemFieldComponent,
        FUITextareaControlComponent,
        FUITextControlComponent,
        FUITextPillComponent,
        FUITimeControlComponent,
        FUITimeSelectorComponent,
        FUITreesComponent,
        FUITreeComponent,
        FUIThreeColumnsComponent,
        FUITwoColumnsComponent,
        FUIValueStatementComponent,
        FUIVideoComponent,
        FUISwitchControlComponent,
        FUICalculatorControlComponent,
        FUIKeysControlComponent,
        FUIKeyComponent,
        FUIPinsControlComponent,
        FUIPinComponent,
        FUIQuantityControlComponent,
        FUIImageControlComponent,
        FUISelectNavComponent,

        FUIEditFormContextComponent,
        FUIFilterFormContextComponent,
        FUIHeaderFormContextComponent,
        FUIInlineFormContextComponent,
        FUIInlineActionFormContextComponent,
        FUIPillFormContextComponent,
        FUIPopFormContextComponent,

        FUITouchDirective,

        ColorTextPipe
    ],
    providers: [
        CurrencyPipe,
        FUIAlertService,
        FUIEditFormContext,
        FUIEventsService,
        FUIEditFormContext,
        FUIFilterFormContext,
        FUIHeaderFormContext,
        FUIInlineFormContext,
        FUIInlineActionFormContext,
        FUIPillFormContext,
        FUIPopFormContext,
        FUIModalsService,
        FUIPopsService,
        FUIStackedPageService,
        FUINavigationService,
        FUINavLayoutService,
        FUIPageService,
        FUIResponsiveService,
        FUISpinnersService
    ]
})
export class UiModule {
    /**
     * Provide the configuration service and the application key used in the configuration form-context.
     * @param config
     * @return ModuleWithProviders
     */
    static forRoot(config: FUIConfig): ModuleWithProviders<UiModule> {
        return {
            ngModule: UiModule,
            providers: [
                config.providedLoader,
                {
                    provide: FUIConfig.NAVIGATION_PATH_KEY, useValue: config.navigationPath
                }
            ]
        };
    }
}
